import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { Client } from "@/types/clients/api-types/client-types";
import { ClientAppointmentHistoryTab } from "./client-appointment-history-tab";
import { ClientAppointmentUpcomingTab } from "./client-appointment-upcoming-tab";

const tabTriggerClass =
  "data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base";

interface ClientAppointmentsDialogProps {
  client: Client;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ClientAppointmentsDialog({
  client,
  open,
  onOpenChange,
}: ClientAppointmentsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[90vh] flex-col overflow-hidden sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            Appointments for {client.first_name} {client.last_name}
          </DialogTitle>
        </DialogHeader>
        <Tabs defaultValue="history" className="flex min-h-0 flex-1 flex-col">
          <TabsList className="h-auto w-full shrink-0 justify-start rounded-none border-b-2 border-border bg-neutral-50 p-0">
            <TabsTrigger className={tabTriggerClass} value="history">
              History
            </TabsTrigger>
            <TabsTrigger className={tabTriggerClass} value="upcoming">
              Upcoming
            </TabsTrigger>
          </TabsList>
          <TabsContent
            value="history"
            className="mt-2 flex min-h-0 flex-1 flex-col overflow-hidden"
          >
            <ClientAppointmentHistoryTab
              clientId={client.id}
              onOpenChange={onOpenChange}
            />
          </TabsContent>
          <TabsContent
            value="upcoming"
            className="mt-2 flex min-h-0 flex-1 flex-col overflow-hidden"
          >
            <ClientAppointmentUpcomingTab
              clientId={client.id}
              onOpenChange={onOpenChange}
            />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
